import React from 'react';

const Testimonial = () => {

  return (
    
    <section className="testimonial-style-three centred p_relative">
        <div className="shape">
            <div className="shape-1" style={{backgroundImage: `url(assets/images/shape/shape-49.png)`}}></div>
            <div className="shape-2" style={{backgroundImage: `url(assets/images/shape/shape-50.png)`}}></div>
        </div>
        <div className="auto-container">
            <div className="sec-title-two mb_50">
                <h5 className="mb_20">Testimonials</h5>
                <h2 className="d_block fs_40 fw_bold mb_25">What Our Patients Say About<br />Sunshine Advanced Eye Care</h2>
            </div>
            <div className="two-item-carousel owl-carousel owl-theme owl-nav-none dots-style-one">
                <div className="testimonial-content">
                    <div className="inner-box">
                        <div className="light-icon"><i className="icon-29"></i></div>
                        <ul className="rating clearfix">
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                        </ul>
                        <p>Being a homemaker from Kurnool, my eyesight was crucial for everyday tasks. Thanks to Sunshine Advance Eye Care Hospital's expert care, my refractive error was corrected, and I can now enjoy a clear view of the world.</p>
                        <h4>Sarada</h4>
                        <span className="designation">Homemaker</span>
                    </div>
                </div>
                <div className="testimonial-content">
                    <div className="inner-box">
                        <div className="light-icon"><i className="icon-29"></i></div>
                        <ul className="rating clearfix">
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                        </ul>
                        <p>I am Rajesh Sharma, a teacher from Kurnool. Thanks to Sunshine Advance Eye Care Hospital, my cataract surgery was a breeze, and now I can see the world with utmost clarity.</p>
                        <h4>Rajesh Sharma</h4>
                        <span className="designation">Teacher</span>
                    </div>
                </div>
                <div className="testimonial-content">
                    <div className="inner-box">
                        <div className="light-icon"><i className="icon-29"></i></div>
                        <ul className="rating clearfix">
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                        </ul>
                        <p>My name is Sunita Patel, and I work as a software engineer in Hyderabad. The LASIK procedure at Sunshine Advance Eye Care Hospital transformed my life by giving me crystal-clear vision without glasses.</p>
                        <h4>Sunita Patel</h4>
                        <span className="designation">Software engineer</span>
                    </div>
                </div>
                <div className="testimonial-content">
                    <div className="inner-box">
                        <div className="light-icon"><i className="icon-29"></i></div>
                        <ul className="rating clearfix">
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                        </ul>
                        <p>As a farmer from Kurnool, I never thought I could afford quality eye care. Sunshine Advance Eye Care Hospital proved me wrong. They treated my glaucoma with expertise and compassion.</p>
                        <h4>Ramesh</h4>
                        <span className="designation">Farmer</span>
                    </div>
                </div>
                <div className="testimonial-content">
                    <div className="inner-box">
                        <div className="light-icon"><i className="icon-29"></i></div>
                        <ul className="rating clearfix">
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                        </ul>
                        <p>I'm Ravi Verma, a businessman from Hyderabad. The skilled team at Sunshine Advance Eye Care Hospital successfully performed my corneal transplant, restoring my vision and confidence.</p>
                        <h4>Ravi Verma</h4>
                        <span className="designation">Businessman</span>
                    </div>
                </div>
                <div className="testimonial-content">
                    <div className="inner-box">
                        <div className="light-icon"><i className="icon-29"></i></div>
                        <ul className="rating clearfix">
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                            <li><i className="icon-40"></i></li>
                        </ul>
                        <p>I am Dr. Sneha Desai, a dentist from Hyderabad. When I needed retinal surgery, I trusted Sunshine Advance Eye Care Hospital. Their advanced techniques and caring staff ensured a successful outcome.</p>
                        <h4>Sneha Desai</h4>
                        <span className="designation">Dentist</span>
                    </div>
                </div>
            </div>
        </div>
        <div className="btn-box">
            <a href="/Testimonials" className="theme-btn btn-one">See more</a>
        </div>
    </section>    
        // <section className="testimonial-section p_relative centred">
        //     <div className="auto-container">
        //         <div className="two-item-carousel owl-carousel owl-theme owl-nav-none owl-dots-none">
        //             <div className="testimonial-block-one">
        //                 <div className="inner-box p_relative d_block">
        //                     <div className="icon-box"><i className="icon-29"></i></div>
        //                     <p>Being a homemaker from Kurnool, my eyesight was crucial for everyday tasks. Thanks to Sunshine Advance Eye Care Hospital's expert care, my refractive error was corrected, and I can now enjoy a clear view of the world.</p>
        //                     <h4>Sarada</h4>
        //                     <span className="designation">Homemaker</span>
        //                 </div>
        //             </div>
        //             <div className="testimonial-block-one">
        //                 <div className="inner-box p_relative d_block">
        //                     <div className="icon-box"><i className="icon-29"></i></div>
        //                     <p>I am Rajesh Sharma, a teacher from Kurnool. Thanks to Sunshine Advance Eye Care Hospital, my cataract surgery was a breeze, and now I can see the world with utmost clarity.</p>
        //                     <h4>Rajesh Sharma</h4>
        //                     <span className="designation">Teacher</span>
        //                 </div>
        //             </div>
        //             <div className="testimonial-block-one">
        //                 <div className="inner-box p_relative d_block">
        //                     <div className="icon-box"><i className="icon-29"></i></div>
        //                     <p>My name is Sunita Patel, and I work as a software engineer in Hyderabad. The LASIK procedure at Sunshine Advance Eye Care Hospital transformed my life by giving me crystal-clear vision without glasses.</p>
        //                     <h4>Sunita Patel</h4>
        //                     <span className="designation">Software engineer</span>
        //                 </div>
        //             </div>
        //             <div className="testimonial-block-one">
        //                 <div className="inner-box p_relative d_block">
        //                     <div className="icon-box"><i className="icon-29"></i></div>
        //                     <p>As a farmer from Kurnool, I never thought I could afford quality eye care. Sunshine Advance Eye Care Hospital proved me wrong. They treated my glaucoma with expertise and compassion.</p>
        //                     <h4>Ramesh</h4>
        //                     <span className="designation">Farmer</span>
        //                 </div>
        //             </div>
        //             <div className="testimonial-block-one">
        //                 <div className="inner-box p_relative d_block">
        //                     <div className="icon-box"><i className="icon-29"></i></div>
        //                     <p>I'm Ravi Verma, a businessman from Hyderabad. The skilled team at Sunshine Advance Eye Care Hospital successfully performed my corneal transplant, restoring my vision and confidence.</p>
        //                     <h4>Ravi Verma</h4>
        //                     <span className="designation">Businessman</span>
        //                 </div>
        //             </div>
        //             <div className="testimonial-block-one">
        //                 <div className="inner-box p_relative d_block">
        //                     <div className="icon-box"><i className="icon-29"></i></div>
        //                     <p>I am Dr. Sneha Desai, a dentist from Hyderabad. When I needed retinal surgery, I trusted Sunshine Advance Eye Care Hospital. Their advanced techniques and caring staff ensured a successful outcome.</p>
        //                     <h4>Sneha Desai</h4>
        //                     <span className="designation">Dentist</span>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // </section>
    );
  }
  
  export default Testimonial;